import { DropResult } from '@hello-pangea/dnd';
import {
  AppointmentProposalOptionProduct,
  useAppointmentProposalOptionProducts,
} from '../../../data-access/appointmentProposalOptionProducts';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';

export const useProductDragAndDrop = () => {
  const { currentOption } = useAppointmentProposalOptions();
  const { updateAppointmentProposalOptionProduct } =
    useAppointmentProposalOptionProducts();
  const { currentProposal, updateAppointmentProposal } =
    useAppointmentProposals();

  const handleDragEnd = (
    result: DropResult,
    items: AppointmentProposalOptionProduct[]
  ) => {
    if (
      !result.destination ||
      result.source.index === result.destination.index ||
      !currentOption
    ) {
      return;
    }

    const {
      appointmentId,
      appointmentProposalId,
      appointmentProposalOptionId,
    } = currentOption;

    if (
      !currentProposal?.presentationConfig.optionItemsDisplayOrder?.some(
        (item) => item.sortBy === 'ADDED_ORDER'
      )
    ) {
      currentProposal &&
        updateAppointmentProposal(
          currentProposal.appointmentId,
          currentProposal.appointmentProposalId,
          {
            presentationConfig: {
              ...currentProposal.presentationConfig,
              optionItemsDisplayOrder: [
                {
                  sortBy: 'ADDED_ORDER',
                  sortDirection: 'ASC',
                  sortPriorityOrder: 0,
                },
              ],
            },
          }
        );
    }

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;
    const sorted = [...items].sort((a, b) => a.sortOrder - b.sortOrder);
    const movedProduct = sorted[sourceIndex];
    const targetProduct = sorted[destinationIndex];
    const updatePromises: Promise<unknown>[] = [];

    updatePromises.push(
      updateAppointmentProposalOptionProduct(
        appointmentId,
        appointmentProposalId,
        appointmentProposalOptionId,
        movedProduct.appointmentProposalOptionProductId,
        { sortOrder: targetProduct.sortOrder }
      )
    );

    if (sourceIndex < destinationIndex) {
      for (let i = sourceIndex + 1; i <= destinationIndex; i++) {
        updatePromises.push(
          updateAppointmentProposalOptionProduct(
            appointmentId,
            appointmentProposalId,
            appointmentProposalOptionId,
            sorted[i].appointmentProposalOptionProductId,
            { sortOrder: sorted[i - 1].sortOrder }
          )
        );
      }
    } else {
      for (let i = destinationIndex; i < sourceIndex; i++) {
        updatePromises.push(
          updateAppointmentProposalOptionProduct(
            appointmentId,
            appointmentProposalId,
            appointmentProposalOptionId,
            sorted[i].appointmentProposalOptionProductId,
            { sortOrder: sorted[i + 1].sortOrder }
          )
        );
      }
    }

    return Promise.all(updatePromises);
  };

  return { handleDragEnd };
};
